var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 1.32826L17.9594 18.5557C17.9594 18.5557 17.4867 19.7508 16.1899 19.1779L11.3526 15.4223L11.3884 15.4507L8.30898 18.2951C8.30898 18.2951 8.0679 18.4794 7.80425 18.3644L8.42659 12.9889C8.42659 12.9889 17.0628 5.12704 17.4167 4.79246C17.7706 4.45789 17.6518 4.38628 17.6518 4.38628C17.6756 3.9801 17.0153 4.38628 17.0153 4.38628L5.57161 11.7468L0.806967 10.1222C0.806967 10.1222 0.0754099 9.85922 0.00415427 9.28517C-0.0682889 8.71229 0.830719 8.4012 0.830719 8.4012L19.7752 0.873947C19.7752 0.873947 21.3333 0.181327 21.3333 1.32826Z",
    fill: "#B3B3C9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.9d1b86d05172209f09b444d961cd4e6b.svg";
export { ForwardRef as ReactComponent };